import request from '@/utils/axios';

import {
  LOAD_NAMED_PARTY_RESULTS_BEGIN,
  LOAD_NAMED_PARTY_RESULTS_ERROR,
  LOAD_NAMED_PARTY_RESULTS_SUCCESS,
} from '../types';

const getResultsBegin = () => {
  return {
    type: LOAD_NAMED_PARTY_RESULTS_BEGIN,
    payload: {
      isFetchingResults: true,
    },
  };
};
const getResultsError = () => {
  return {
    type: LOAD_NAMED_PARTY_RESULTS_ERROR,
    payload: {
      isFetchingResults: false,
    },
  };
};
const getResultsSuccess = (count, results) => {
  return {
    type: LOAD_NAMED_PARTY_RESULTS_SUCCESS,
    payload: {
      isFetchingResults: false,
      count,
      results,
    },
  };
};

export default payload => {
  return async dispatch => {
    try {
      await dispatch(getResultsBegin());
      const response = await request({
        url: 'amicus/casesearch',
        method: 'POST',
        data: payload.searchOptions,
        triggerLoad: false,
      });
      const { data } = response;
      if (data && data.Count) {
        const {
          data: { Count, LegalCases },
        } = response;
        await dispatch(getResultsSuccess(Count, LegalCases));
      }
      if (data.Count === 0) {
        await dispatch(getResultsSuccess(0, []));
      }
    } catch (err) {
      console.warn(err);
      await dispatch(getResultsError());
    }
  };
};
